import { getVendorBusinessImageUrl } from "../helpers/mediaUrl";

export default class vendorServicing_navbar {
  constructor() {
    window.vendorNav = this;
    window.vendorServicing_navbar = this;
    this.bindEvents();
    this.load_vendor_Details();

    // Handle browser back/forward buttons
    window.addEventListener("popstate", () => {
      this.sidebarFunctionVendor();
    });

    // this.showAllPages();
  }

  bindEvents = () => {
    var $homeIcon = $("#sidebarMenu");

    if (window.innerWidth <= 1000) $homeIcon.removeClass("show");
    else $homeIcon.addClass("show");

    $(".vendor-nav-option").on("click", this.sidebarFunctionVendor);
    this.sidebarFunctionVendor();

    //Function executed when window is resized
    $(window).resize(() => {
      this.reAdjustSideBar();
    });
  };

  load_vendor_Details = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getVendorDetails",
      headers: { Authorization: X_API_KEY },
      success: this.show_vendor_nav_details,
    });
  };

  show_vendor_nav_details = async (res) => {
    // $("#inputBusinessName").attr(res.Business_Name);
    // document.getElementById("inpBusinessImg").fileLabel = "";

    const navImage = document.getElementById("vendor_nav_image");
    if (navImage) {
      navImage.src = getVendorBusinessImageUrl(res.Image_URL, 1);
      navImage.onerror = function () {
        this.onerror = null;
        this.src = "https://img.icons8.com/material-rounded/28/FF385C/guest-male.png";
      };
    }
    // document.getElementById("vendor_nav_name").value = res.Business_Name;
    var desktopVendorName = res.Business_Name;
    if (desktopVendorName.length > 10) {
      desktopVendorName = desktopVendorName.substring(0, 8) + "..";
    }
    // $(".accountNameDesktop").html(
    //   `<a href="${baseURL}customer/account" class="truncate-account-name-desktop" style="color:black;">${desktopName}</a>`
    // );
    $("#vendor_nav_name").html(`${desktopVendorName}`);

    // document.getElementById("inputBusinessName").value = res.Business_Name;
  };

  reAdjustSideBar = () => {
    //checking the size of the screen
    var screenWidthForLeftNav = $(window).width();

    if (screenWidthForLeftNav <= 991) {
      //show mobile view
      $("#sidebarMenu").removeClass("show");
    } else {
      $("#sidebarMenu").addClass("show");
    }
  };

  sidebarFunctionVendor = (event) => {
    this.reAdjustSideBar();

    const pathname = window.location.pathname;
    const isDashboard = pathname.endsWith("Vendor_servicing_dashboard");

    if (event != undefined && !isDashboard) {
      const page = event.currentTarget.classList[1];
      window.location.href = baseURL + "Vendor_servicing_dashboard?page=" + page;
      return;
    }

    // Hide sidebar menu entirely as we are using dashboard navigation
    $("#sidebarMenu").removeClass("show").hide();

    // Determine the page to show
    let page;
    if (event && event.currentTarget) {
      page = event.currentTarget.classList[1];

      // Update URL without refreshing
      const url = new URL(window.location);
      const currentPage = url.searchParams.get("page") || "vendor-dashboard";

      if (page !== currentPage) {
        if (page === "vendor-dashboard" || page === "vendor-Dashboard") {
          url.searchParams.delete("page");
        } else {
          url.searchParams.set("page", page);
        }
        window.history.pushState({}, "", url);
      }
    } else {
      // Initial load or popstate: get from URL
      const urlParams = new URLSearchParams(window.location.search);
      page = urlParams.get("page") || "vendor-dashboard";
    }

    if (page == "nav-account" || page == "collapsed") {
      if (event && event.currentTarget) $(event.currentTarget).addClass("active");
    } else {
      $(".vendor-nav-option").removeClass("active");
      if (event && event.currentTarget) {
        $(event.currentTarget).addClass("active");
      } else {
        $(`.vendor-nav-option.${page}`).addClass("active");
      }
      $(".currentlyActive").addClass("d-none");
      $(".currentlyActive").removeClass("currentlyActive");
    }

    // Show/Hide Top Navbar and Back Button
    if (page == "vendor-Dashboard" || page == "vendor-dashboard" || page == "vendor-DashboardPage") {
      // UI updates for dashboard
      $(".VendorDashboardPage").addClass("currentlyActive");
      $(".VendorDashboardPage").removeClass("d-none");
      $("#vendorBackToDashboard").addClass("d-none");
      $(".nav_bar").addClass("d-none");
      $(".vendor-servicing-main").css("margin-top", "0");
    } else {
      $(".nav_bar").removeClass("d-none"); // Show top navbar on other pages
      $("#vendorBackToDashboard").removeClass("d-none");

      if (page == "vendor-orders") {
        $(".vendororders").addClass("currentlyActive");
        $(".vendororders").removeClass("d-none");
      } else if (page == "quote-dashboard") {
        $(".vendorQuoteDashboard").addClass("currentlyActive");
        $(".vendorQuoteDashboard").removeClass("d-none");
      } else if (page == "vendor-quotes" || page == "vendor-quote-requests") {
        $(".vendorQuoteRequestsPage").addClass("currentlyActive");
        $(".vendorQuoteRequestsPage").removeClass("d-none");
        if (window.vendorQuoteRequests) window.vendorQuoteRequests.refresh();
      } else if (page == "vendor-profile") {
        $(".vendor_name_edit_page").addClass("currentlyActive");
        $(".vendor_name_edit_page").removeClass("d-none");
      } else if (page == "vendor-address") {
        $(".VendorAddressDiv").addClass("currentlyActive");
        $(".VendorAddressDiv").removeClass("d-none");
      } else if (page == "vendor-security") {
        $(".VendorAccountSecurity").addClass("currentlyActive");
        $(".VendorAccountSecurity").removeClass("d-none");
      } else if (page == "vendor-document") {
        $(".vendorServicingDocuments").addClass("currentlyActive");
        $(".vendorServicingDocuments").removeClass("d-none");
      } else if (page == "vendor-billing") {
        $(".vendor_billing_desktop").addClass("currentlyActive");
        $(".vendor_billing_desktop").removeClass("d-none");
      } else if (page == "vendor-categories") {
        $(".Vendor_category_speciality_details_page").addClass("currentlyActive");
        $(".Vendor_category_speciality_details_page").removeClass("d-none");
      } else if (page == "vendor-inventory") {
        $(".vendor_servicing_product_listing").addClass("currentlyActive");
        $(".vendor_servicing_product_listing").removeClass("d-none");
      } else if (page == "vendor-delivery-options") {
        $(".deliveryDetailsPage").addClass("currentlyActive");
        $(".deliveryDetailsPage").removeClass("d-none");
      } else if (page == "vendor-gst") {
        $(".GSTDetails-page").addClass("currentlyActive");
        $(".GSTDetails-page").removeClass("d-none");
      } else if (page == "vendor-calender") {
        $(".vendorCalenderPage").addClass("currentlyActive");
        $(".vendorCalenderPage").removeClass("d-none");
      } else if (page == "vendor-help") {
        $(".vendor_Help_Page").addClass("currentlyActive");
        $(".vendor_Help_Page").removeClass("d-none");
      } else if (page == "vendor-payments") {
        $(".vendorPoints").addClass("currentlyActive");
        $(".vendorPoints").removeClass("d-none");
      } else if (page == "vendor-payment-history") {
        $(".vendor_servicing_payment").addClass("currentlyActive");
        $(".vendor_servicing_payment").removeClass("d-none");
      } else if (page == "vendor-email-reports") {
        $(".vendor_email_report").addClass("currentlyActive");
        $(".vendor_email_report").removeClass("d-none");
      } else if (page == "vendor-paid-promotion") {
        $(".vendor_servicing_pricing").addClass("currentlyActive");
        $(".vendor_servicing_pricing").removeClass("d-none");
      } else if (page == "vendor-ai-promotion") {
        $(".AIPromotionPage").addClass("currentlyActive");
        $(".AIPromotionPage").removeClass("d-none");
      } else if (page == "vendor-website-builder" || page == "vendor-website-templates") {
        $(".vendorWebsiteTemplatesPage").addClass("currentlyActive");
        $(".vendorWebsiteTemplatesPage").removeClass("d-none");
      } else if (page == "vendor-logout") {
        this.redirectToLogInVendor();
      }
    }
  };

  showAllPages = () => {
    $(".VendorDashboardPage").removeClass("d-none");
    $(".vendororders").removeClass("d-none");
    $(".vendor_name_edit_page").removeClass("d-none");
    $(".VendorAddressDiv").removeClass("d-none");
    $(".VendorAccountSecurity").removeClass("d-none");
    $(".vendorServicingDocuments").removeClass("d-none");
    $(".vendor_billing_desktop").removeClass("d-none");
    $(".Vendor_category_speciality_details_page").removeClass("d-none");
    $(".vendor_servicing_product_listing").removeClass("d-none");
    $(".deliveryDetailsPage").removeClass("d-none");
    $(".GSTDetails-page").removeClass("d-none");
    $(".vendorCalenderPage").removeClass("d-none");
    $(".vendor_Help_Page").removeClass("d-none");
    $(".vendorPoints").removeClass("d-none");
    $(".vendor_email_report").removeClass("d-none");
    $(".vendorWebsiteTemplatesPage").removeClass("d-none");
    $(".vendor_servicing_pricing").removeClass("d-none");
    $(".AIPromotionPage").removeClass("d-none");
  };
  navigateToDashboard = () => {
    $(".currentlyActive").addClass("d-none").removeClass("currentlyActive");
    $(".VendorDashboardPage").addClass("currentlyActive").removeClass("d-none");
    $("#vendorBackToDashboard").addClass("d-none");
    $(".nav_bar").addClass("d-none");
    $(".vendor-servicing-main").css("margin-top", "0");

    // Clear URL parameter
    const url = new URL(window.location);
    if (url.searchParams.has("page")) {
      url.searchParams.delete("page");
      window.history.pushState({}, "", url);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  redirectToLogInVendor = () => {
    // UtilObject.eraseCookie("CUSTOMER_ID");
    $.ajax({
      url: baseURL + "api/vendor/unsetSessionValuesVendor",
      type: "POST",
      data: {
        unset: "Vendor_ID",
      },
      success: (result) => {
        window.location = baseURL + "Vendor_login";
      },
    });
  };
}


